import { render, staticRenderFns } from "./TabGraficoParticipacaoValorTotalDepreciacoes.vue?vue&type=template&id=8a1c799a&scoped=true&"
import script from "./TabGraficoParticipacaoValorTotalDepreciacoes.vue?vue&type=script&lang=js&"
export * from "./TabGraficoParticipacaoValorTotalDepreciacoes.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoParticipacaoValorTotalDepreciacoes.vue?vue&type=style&index=0&id=8a1c799a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1c799a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTab,VTabItem,VTabs})
